import React, { useEffect, useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  TablePagination,
  Typography,
  Grid, Box
} from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import DeleteIcon from '@mui/icons-material/Delete'
import Switch from '@mui/material/Switch'
import {
  ApiGetAllRoles,
  ApiGetAdminList,
  ApiPutUpdateAdminRole,
  ApiPutUpdateAdminStatus
} from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'




const ManageAdmin: React.FC = () => {
  const [adminUsers, setAdminUsers] = useState<any>([])
  const [roles, setRoles] = useState<any>([])
  const [datalength, setdatalength] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const navigate = useNavigate()
  const openEditAccessGroup = () => {
    navigate('/admin/edit-access-group')
  }
  const addOrUpdateAdmin = (id?: number) => {
    if (id) {
      navigate(`/admin/add-or-update/update/${id}`)
    } else {
      navigate('/admin/add-or-update/add')
    }
  }
  useEffect(() => {
    const fetchData = async () => {
      await handleGetApiCallRoles()
      await handleGetApiCall()
    }
    fetchData()
    return () => { }
  }, [page, rowsPerPage])

  const handleGetApiCallRoles = async () => {
    const data: any = {}
    try {
      const response: any = await ApiGetAllRoles(data)
      setRoles(response.data)
    } catch (error) {
      console.error('Error during API call:', error)
    }
  }
  const handleGetApiCall = async () => {
    const data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}`
    try {
      const response: any = await ApiGetAdminList(data)
      setdatalength(response.totalDataCount)
      setAdminUsers(response.data)
    } catch (error) {
      console.error('Error during API call:', error)
    }
  }

  const typeOptions = roles.map(role => ({
    label: role.roleDisplayName,
    value: role.roleName
  }))

  const handleChange = async (user, newStatus: string) => {
    try {
      const payload = {
        userId: user.userId,
        status: newStatus
      }
      await ApiPutUpdateAdminStatus(payload)
      await handleGetApiCall()
    } catch (error) {
      console.error('Error updating user status:', error)
      toast.error('Failed to update user status')
    }
  }
  const handleTypeChange = async (
    event: any,
    newValue: any,
    userId: number
  ) => {
    if (newValue) {
      try {
        const payload = {
          userId: userId,
          role: newValue.value
        }
        const response = await ApiPutUpdateAdminRole(payload)
        toast.success('Role updated successfully')
        await handleGetApiCall()
      } catch (error) {
        console.error('Error updating role:', error)
      }
    }
  }

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  ;

  const handleDeleteUser = async (userId: number, status: string) => {
    const isConfirm = window.confirm("Are you Sure you want to delte this user?")
    if (isConfirm) {
      try {
        const data = {
          userId: userId,
          status: status
        }
        const response = await ApiPutUpdateAdminStatus(data);
        if (response?.status) {
          toast.success("User deleted successfully.")
          await handleGetApiCall()
        }
      } catch (error: any) {
        console.error("Error deleting User.", error);
        toast.error(error?.message)
      }
    }
  }
  return (
    <Box className='w-100 bg-white border-10 p-2'>
      <Box className='py-3 px-0 px-md-1'>
        <Grid container gap={2} alignItems={'center'} className='mb-4 w-100'>
          <Grid size={{ xs: 12, md: 'grow' }}>
            <Typography className='fs-42 text-center'>Admin Users</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 'auto' }}>
            <div className='d-flex justify-content-end'>
              <Link
                to={'/admin/add-or-update/add'}
                // variant='contained'
                // onClick={() => addOrUpdateAdmin()}
                className='table-row-background link-btn  fs-14'
              >
                Add New Admin
              </Link>
            </div>
          </Grid>
        </Grid>
        <Box className='w-100' overflow={'auto'}>
          <Table>
            <TableHead>
              <TableRow className='table-row-background'>
                {["Name", "UserName", "Password", "Email", "Type", "Active"].map((item, index) => (<TableCell className='fs-14' key={index} style={{ color: '#fff' }}>{item}</TableCell>))}
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {adminUsers?.map(user => (
                <TableRow key={user.id}>
                  {/* <TableCell>
                <Button
                  variant='contained'
                  onClick={openEditAccessGroup}
                  className='table-row-background'
                >
                  Group
                </Button>
              </TableCell> */}
                  <TableCell className='fs-14'>{user.displayName}</TableCell>
                  <TableCell className='fs-14'>{user.userName}</TableCell>
                  <TableCell className='fs-14'>****</TableCell>
                  <TableCell className='fs-14'>{user.emailId}</TableCell>
                  <TableCell className='fs-14'>
                    <div>
                      <Autocomplete
                        options={typeOptions.filter((_, index) => index < 3)}
                        value={typeOptions.find(
                          option => option.label === user.role.roleDisplayName
                        )}
                        getOptionLabel={option => option.label}
                        onChange={(event, newValue) =>
                          handleTypeChange(event, newValue, user.userId)
                        }
                        renderInput={params => (
                          <TextField {...params} label='Type' />
                        )}
                        fullWidth
                      />
                    </div>
                  </TableCell>

                  <TableCell>
                    <div className='switch-admin'>
                      <Switch
                        checked={user?.userStatus?.userStatus === 'active'}
                        onChange={e => {
                          const newStatus = e.target.checked ? 'active' : 'inActive'
                          handleChange(user, newStatus)
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </div>
                  </TableCell>

                  <TableCell>
                    <Link
                      to={`/admin/add-or-update/update/${user.userId}`}
                      // variant='contained'
                      // onClick={() => addOrUpdateAdmin(user.userId)}
                      className='table-row-background fs-14 link-btn'
                    >
                      Edit
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Button variant='contained' onClick={() => { handleDeleteUser(user.userId, "delete") }} className='delete-transparent'>
                      <DeleteIcon className='delete-icon' />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={datalength}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Box>
  )
}

export default ManageAdmin
